import { includesError } from '@/common/errors';
import { useEffect, useState } from 'react';

export const scanErrors = {
	alreadyScanned: 'This code has already been scanned',
	invalidCode: 'The code you have entered is invalid',
	unknownError: 'Something went wrong trying to scan this code',
};

export const useScanResult = () => {
	const [apiErrors, setApiErrors] = useState<readonly { message: string }[] | undefined>();
	const [scanError, setScanError] = useState<string | undefined>();

	useEffect(() => {
		if (apiErrors === undefined) {
			setScanError(undefined);
		} else if (includesError(apiErrors, 'User has already scanned this asset')) {
			setScanError(scanErrors.alreadyScanned);
		} else if (includesError(apiErrors, 'Invalid code')) {
			setScanError(scanErrors.invalidCode);
		} else {
			setScanError(scanErrors.unknownError);
		}
	}, [apiErrors]);

	return { scanError, setApiErrors };
};
